
const mainThemeColor = 'black'
const mainThemeColorLight = '#2f4f4f'

export {mainThemeColor, mainThemeColorLight}